export const Banner = () => (
  <div className="flex h-14 items-center bg-[#173d2f] px-6 font-haboro-soft text-[16px] text-white">
    <p className="font-normal">
      <span className="font-semibold">Free delivery over $79 in Victoria, and $99 in Sydney Metro</span>{' '}
      <span className="hidden sm:inline-block">(National delivery coming soon)</span>
    </p>
  </div>
);
